import React, { FC, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import FormField from "../../../components/common/FormField";
import { userAllFields } from "./userAllFields";
import { useDispatch } from "react-redux";
import { getCheckUniqueEmailAction } from "../../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";
import { getAllUserRolesAction } from "../../../store/reducers/subUserSlice";
interface ManageUserInfoProps {
  selectUser: any; // Adjust type as per your requirement
  onChange: (field: string, value: any) => void; // Add onChange prop type
  checkValidator?: any;
  resetValidator?: any;
  error?: any;
  userDetail?: any;
  isEmailActionCalled?: boolean;
  setIsEmailActionCalled?: any;
  setCountryCode?: any;
  countryCode?: any;
}
const UserInfoForm: FC<ManageUserInfoProps> = ({
  checkValidator,
  resetValidator,
  error,
  userDetail,
  selectUser,
  onChange,
  isEmailActionCalled,
  setIsEmailActionCalled,
  setCountryCode,
  countryCode,
}) => {
  const dispatch = useDispatch();
  const { isEmailError } = useSelector((state: any) => state?.adminClients);
  const { userRoles, newUserLocal } = useSelector(
    (state: any) => state.subUser
  );

  useEffect(() => {
    dispatch(getAllUserRolesAction());
  }, []);

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
    if (e.target.id === "email" && e.target.value.trim() !== "") {
      setIsEmailActionCalled(true);
      document.body.style.cursor = "wait"; // start loading cursor
    }
  };

  useEffect(() => {
    if (isEmailActionCalled) {
      if (error && !error["email"] && isEmailActionCalled) {
        dispatch(getCheckUniqueEmailAction(userDetail?.email));
        setIsEmailActionCalled(false);
      } else {
        setIsEmailActionCalled(false);
      }
    }
  }, [isEmailActionCalled]);

  // reset cursor after check finishes
  useEffect(() => {
    // suppose your slice has loading flag (recommended way)
    if (!isEmailError) {
      document.body.style.cursor = "default";
    }
  }, [isEmailError]);

  const updatedField = userAllFields.map((field) => {
    if (field.id === "roles") {
      return {
        ...field,
        options: userRoles.map((role: any) => role?.role),
      };
    }
    return field;
  });

  return (
    <>
      <Grid container spacing={0.5} sx={{background:'#E5F4F1',border:'1px solid #CFCFCF',borderRadius:'5px',padding:'10px'}}>
        {updatedField.map((field, i) => {
          return (
            <FormField
              key={i}
              onPaste={(e) => field?.id ==='email' ? '' : e.preventDefault()}
              onKeyDown={(event: any) => {
                console.log(
                  "event log-",
                  event,
                  event.target.value + event.key
                );
                if (
                  event.keyCode === 8 ||
                  event.keyCode === 9 ||
                  event.keyCode === 37 ||
                  event.keyCode === 38 ||
                  event.keyCode === 39 ||
                  event.keyCode === 40 ||
                  event.keyCode === 18 ||
                  event.keyCode === 17 ||
                  event.ctrlKey
                )
                  return event;
                if (
                  field?.patternAllowed &&
                  !field?.patternAllowed.test(event.key)
                ) {
                  event.preventDefault();
                } else if (
                  field?.patternAllowed &&
                  !field?.patternAllowed.test(event.target.value + event.key)
                ) {
                  event.preventDefault();
                }
              }}
              {...{
                ...field,
                ...{
                  variant: "outlined", // Adding this variant prop
                  marginLeftCountryCode: "-14px",
                  inSingleGridForm: true,
                  flexDirection:'row',
                  isNonMarginTop: true,
                  onCountryCodeChange:
                    field.type === "contact" // Example of checking if it's a country code field
                      ? (code: string) => setCountryCode(code)
                      : undefined, // or you could pass a default function if necessary
                  ...{
                    ...(field?.type === "contact" && {
                      countryCode: userDetail[field.id] ? countryCode : "",
                    }),
                  },
                  InputProps: {
                    ...(field?.inputProps && field?.inputProps),
                    sx: { height: "36px" },
                    ...(selectUser && {
                      disabled:
                        field?.id === "email" &&
                        selectUser?.status === "PENDING"
                          ? false
                          : field?.editReadOnly,
                    }),
                    autocomplete: "user-new-field",
                  },
                  value: userDetail ? userDetail[field.id] : "",
                  onBlur: onBlurAction,
                  selectedValues:
                    field.id === "roles"
                      ? Array.isArray(userDetail.roles)
                        ? userDetail.roles
                        : typeof userDetail.roles === "string"
                        ? [userDetail.roles]
                        : []
                      : undefined,
                  onChange: (e: any) => onChange(field.id, e.target.value), // Call onChange prop
                  error:
                    field?.id === "email" && isEmailError
                      ? true
                      : error && error[field?.id],
                },
              }}
            />
          );
        })}
      </Grid>
    </>
  );
};
export default UserInfoForm;
